$(document).ready(function () {

    // Parse the variant details JSON
    const variantDetailsScript = document.getElementById("variant_details");
    if (!variantDetailsScript) {
        console.error("Variant details script not found!");
        return;
    }
    const variantDetails = JSON.parse(variantDetailsScript.textContent);
    const productVariants = variantDetails.product_variants;

    $(document).on('click', '.pdp-customize-me-btn', function (event) {
        event.preventDefault();
        const __this = $(this);
        const buttonURL = __this.attr('href');

        const selectedQty = parseInt($('.quantity_selector--wrapper .customize_wrapper .quantity__input[name="quantity"]').val(), 10);
        const selectedVariantId = $(this).closest('form').find('input[name="id"]').val();
        const variant = productVariants.find(v => v.id === selectedVariantId);
        // console.log('variant',variant);
        const selectedVariantInventoryManagement = variant.inventory_management;
        const selectedVariantInventoryPolicy = variant.inventory_policy;

        const variantCount = __this.closest('product-info').find('#swatch-option1[option-name="Size"] .swatch-view-item').length;

        if (variantCount >= 2) {
            __this.closest('product-info').find('#swatch-option1[option-name="Size"] .swatch-view-item').each(function (index) {

                const isSelected = $(this).find('.swatch-button').hasClass('swatch-selected');
                const isAvailable = !$(this).hasClass('swatch-item-unavailable');

                if (isSelected && isAvailable) {
                    console.log('Correct Variant has been selected!');
                    __this.removeClass('variant-not-selected');

                    const availableInventory = parseInt(variant.inventory_qty, 10);
                    // Check if the selected quantity exceeds available inventory
                    if (selectedQty > availableInventory && selectedVariantInventoryManagement == 'shopify') {
                        if(selectedVariantInventoryPolicy == 'continue') {
                            console.log('continue policy REDIRECT');
                            location.href = buttonURL;
                            return false;
                        } else {
                            const message = availableInventory === 1
                                ? `Only 1 unit of this variant is available.`
                                : `Only ${availableInventory} units of this variant are available.`;
                            $('.customize_wrapper-btn-errors').html(`<span>${message}</span>`);
                            setTimeout(function(){
                                $('.customize_wrapper-btn-errors').html('');
                            },5000);
                        }
                    } else {
                        console.log('Second MAIN REDIRECT');
                        location.href = buttonURL;
                        return false; // Stop further iteration
                    }
                    return false;
                } else {
                    console.log('Not the correct variant.');
                    __this.addClass('variant-not-selected');
                }
            });
        } else {
            console.log('MAIN REDIRECT');
            location.href = buttonURL;
        }
    });

    // ADD TO CART BUTTON
    $(document).on('click', '.product-form__submit', function (event) {
        event.preventDefault();
        const __this = $(this);

        const variantCount = __this.closest('product-info').find('#swatch-option1[option-name="Size"] .swatch-view-item').length;

        if (variantCount >= 2) {
            __this.closest('product-info').find('#swatch-option1[option-name="Size"] .swatch-view-item').each(function (index) {
                const isSelected = $(this).find('.swatch-button').hasClass('swatch-selected');
                const isAvailable = !$(this).hasClass('swatch-item-unavailable');

                if (isSelected && isAvailable) {
                    console.log('Correct Variant has been selected!');
                    __this.removeClass('variant-not-selected');
                    // __this.closest('.tab-button').find('.product-form__submit[name=add]').trigger('click');
                    const formData = __this.closest('form').serialize();
                    pdp_add_to_cart(formData)
                    return false;
                } else {
                    console.log('Not the correct variant.');
                    __this.addClass('variant-not-selected');
                }
            });
        } else {
            const formData = __this.closest('form').serialize();
            pdp_add_to_cart(formData);
            return false;
        }
    });

    function pdp_add_to_cart(formData) {
        // console.log('form data',formData);
        let productData = formData;
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: productData,
            dataType: 'json', 
            success: function (data) {
                pdp_cart_update();
            }
        });
    }

    function pdp_cart_update() {
        fetch(window.Shopify.routes.root + '?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
            const cartid = 'CartDrawer';
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.querySelector('#CartDrawer');
            const source = html.getElementById(cartid);
            if (source && destination) destination.innerHTML = source.innerHTML;
            $.ajax({
                url: '/?section_id=cart-icon-bubble',
                type: 'GET',
                dataType: 'html',
                success: function (itemcount) {
                    $('.drawer').removeClass('is-empty');
                    $("#cart-icon-bubble").html($(itemcount).html());
                    $(".cart-count-bubble").trigger("click");
                    console.log('cart updated');
                }
            });
        });
    }
});
